import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from '../common/Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

function _ContactMeta(props) { return <LabelValue {...props} value={props.content} /> }
const ContactMeta = withLabelTokenParsing(_ContactMeta, (props, keyword, options) => {
        const data = props.data || {};
        let replaceString = '';
        switch (keyword) {
            case Token.CompanyName:
                if (!Utilities.isNullOrWhitespace(data.BilledToCompany)) {
                    replaceString = Token.getReplacementString(data.BilledToCompany, options);
                }
                break;
            case Token.Name:
                if (!Utilities.isNullOrWhitespace(data.BilledToName)) {
                    replaceString = Token.getReplacementString(data.BilledToName, options);
                }
                break;
            default:
                replaceString = undefined;
                break;
        }
        return replaceString;
    }
);
const Tokens = () => [
    Token.getWrappedTokenConfig('Contact Name', Token.Name),
    Token.getWrappedTokenConfig('Company Name', Token.CompanyName)
];
const TypeConfig = {
    panel: {
        block: LabelValueTypeConfig.panel.block,
        description: LabelValueTypeConfig.panel.description,
        label: () => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: 'Prepared For:'})),
        style: LabelValueTypeConfig.panel.style,
        value: () => LabelValueTypeConfig.panel.value(`${Utilities.wrapTextForEditor({ text: `{${Token.Name}("before":"","after":"")}`, token: Token.Name })}${Utilities.wrapTextForEditor({ text: `{${Token.CompanyName}("before":"","after":"")}`, token: Token.CompanyName })}`),
    }
};

export {
    ContactMeta as Component,
    Tokens,
    TypeConfig
};